import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../../lib/api";
import { Clock, Users, CheckCircle2, Dumbbell, ChevronRight } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ pending: 0, approved: 0, users: 0, challenges: 0 });
    const [recent, setRecent] = useState([]);

    useEffect(() => {
        Promise.all([
            client.get("/admin/submissions", { params: { status: "pending", limit: 200 } }),
            client.get("/admin/submissions", { params: { status: "approved", limit: 1 } }),
            client.get("/admin/users", { params: { limit: 1 } }),
            client.get("/admin/challenges"),
        ]).then(([p, a, u, c]) => {
            setStats({
                pending: p.data.total,
                approved: a.data.total,
                users: u.data.total,
                challenges: c.data.length,
            });
            setRecent(p.data.items.slice(0, 5));
        });
    }, []);

    return (
        <div>
            <span className="label-cap text-xs text-neon-green">Overview</span>
            <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">Command Center</h1>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-6">
                <Stat icon={Clock} label="Pending" value={stats.pending} c="#F59E0B" />
                <Stat icon={CheckCircle2} label="Approved" value={stats.approved} c="#39FF14" />
                <Stat icon={Users} label="Users" value={stats.users} c="#FF3B30" />
                <Stat icon={Dumbbell} label="Challenges" value={stats.challenges} c="#39FF14" />
            </div>

            <div className="mt-8">
                <div className="flex items-end justify-between">
                    <h2 className="font-display font-black text-2xl uppercase tracking-tight">Pending Reviews</h2>
                    <Link to="/admin/review" className="text-xs label-cap text-zinc-400 hover:text-white">
                        View All
                    </Link>
                </div>
                <div className="mt-3 space-y-2">
                    {recent.length === 0 ? (
                        <div className="surface-1 p-6 text-center text-zinc-400">No pending submissions.</div>
                    ) : (
                        recent.map((s) => (
                            <Link
                                key={s.id}
                                to="/admin/review"
                                data-testid={`admin-pending-${s.id}`}
                                className="surface-1 p-3 flex items-center gap-3 hover:border-neon-green"
                            >
                                <div className="w-2 h-2 rounded-full bg-neon-orange shadow-[0_0_8px_#FF3B30]" />
                                <div className="flex-1 min-w-0">
                                    <div className="font-display font-bold uppercase text-sm leading-none truncate">
                                        {s.user_name} · {s.challenge_title}
                                    </div>
                                    <div className="text-xs text-zinc-500 mt-1">
                                        {new Date(s.submitted_at).toLocaleString()}
                                    </div>
                                </div>
                                <ChevronRight size={16} className="text-zinc-500" />
                            </Link>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

function Stat({ icon: Icon, label, value, c }) {
    return (
        <div className="surface-1 p-4">
            <Icon size={18} style={{ color: c }} />
            <div className="font-display font-black text-3xl mt-2" style={{ color: c }}>
                {value}
            </div>
            <div className="label-cap text-xs text-zinc-500">{label}</div>
        </div>
    );
}
